import { BASE_PATH, BASE_PATH_EXTENSION_ADMIN } from "../../utils/constants";
import {getToken} from "../Auth/token";
import axios from "axios";

const urlBase = `${BASE_PATH}${BASE_PATH_EXTENSION_ADMIN}/transaction`

export async function addTransaction(props) {
    const config = {headers: { 'Authorization': `Bearer ${getToken()?.primaryUser?.token}`}};
    return axios.post(`${urlBase}/create`, props, config)
}

export async function addManualTransaction(props) {
    const config = {headers: { 'Authorization': `Bearer ${getToken()?.primaryUser?.token}`}};
    return axios.post(`${urlBase}/create-manual`, props, config)
}

export async function getTransactionByID(props) {
    const config = {headers: { 'Authorization': `Bearer ${getToken()?.primaryUser?.token}`}};
    return axios.post(`${urlBase}/info`, props, config)
}

export async function exportTransaction(props) {
    const config = {
        headers: {
            'Authorization': `Bearer ${getToken()?.primaryUser?.token}`,
            'Content-Type': 'application/json'
        },
        responseType: 'blob' // ← necesario para manejar ficheros
    };

    return axios.post(`${urlBase}/export`, props, config);
}

export async function apiTransactionCronJob() {
    const config = {headers: { 'Authorization': `Bearer ${getToken()?.primaryUser?.token}`}};
    return axios.get(`${urlBase}/cronjob-info`, config)
}

export async function apiTransactionCronJobUpdateNext(props) {
    const config = {headers: { 'Authorization': `Bearer ${getToken()?.primaryUser?.token}`}};
    return axios.post(`${urlBase}/cronjob-update-next`, props, config)
}

export async function apiTransactionUpdateDatePayment(props) {
    const config = {headers: { 'Authorization': `Bearer ${getToken()?.primaryUser?.token}`}};
    return axios.post(`${urlBase}/update-payment-date`, props, config)
}

export async function apiTransactionResendVerifactu(props) {
    const config = {headers: { 'Authorization': `Bearer ${getToken()?.primaryUser?.token}`}};
    return axios.post(`${urlBase}/resend-verifactu/${props.transactionId}`, {}, config)
}

export async function apiTransactionSendClientTransaction(props) {
    const config = {headers: { 'Authorization': `Bearer ${getToken()?.primaryUser?.token}`}};
    return axios.post(`${urlBase}/send-client-transaction`, props, config)
}